export const laborContractRouter = [
  {
    path: "/staff-manage/labor-contract/list",
    name: "labor-contract-list",
    meta: { title: "劳动合同" },
    component: () => import(/* webpackChunkName: "labor-contract-list" */ "@/views/staff-manage/labor-contract/list/index.vue"),
  },
  {
    path: "/staff-manage/labor-contract/add",
    name: 'labor-contract-add',
    meta: { title: '新增劳动合同', comName: "StaffManageLaborContractFormCreate" },
    hidden: true,
    component: () => import(/* webpackChunkName: "labor-contract-add " */ "@/views/staff-manage/labor-contract/form-create/index.vue")
  },
  {
    path: "/staff-manage/labor-contract/edit/:id",
    name: 'labor-contract-edit',
    meta: { title: '编辑劳动合同', comName: "StaffManageLaborContractFormCreate" },
    hidden: true,
    component: () => import(/* webpackChunkName: "labor-contract-edit" */ "@/views/staff-manage/labor-contract/form-create/index.vue")
  },
  {
    path: "/staff-manage/labor-contract/detail/:id",
    name: 'labor-contract-detail',
    meta: { title: '劳动合同详情' },
    hidden: true,
    component: () => import(/* webpackChunkName: "labor-contract-detail" */ "@/views/staff-manage/labor-contract/form-detail/index.vue")
  },
  {
    hidden: true,
    path: "/staff-manage/labor-contract/flowPrint/:id",
    name: "labor-contract-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/staff-manage/labor-contract/flow-print/index.vue"
      ),
  },
]
